// extracted by mini-css-extract-plugin
export default {"borderWrapper":"DidYouKnow_borderWrapper__FnPoO","header":"DidYouKnow_header__XzxiX","premiumBadge":"DidYouKnow_premiumBadge__h1ohL","badgeText":"DidYouKnow_badgeText__nVjQk"};